// global detect methods
;(function (lxk, undefined) {
  lxk.detect = function (uaStr) {
    var result = {
      os: {}
    };

    function parseOS(obj) {
      var i;
      var UNKNOWN = 'Unknown';
      var DEFAULT_X64_LABEL = '(64-bit)';
      var x64Suffix = '';
      var osKey = [
        /* 
         * cannot use lookbehind due to lack of support
         * in many browsers. See the URLs below for details
         *
         * - https://caniuse.com/#feat=js-regexp-lookbehind
         * - https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
         *
         * Also avoid flags on Windows/Mac checks due to lack of support in Internet Explorer
         *
         * OBJECT KEY/VALUE
         *   family     - generic family name (linux, mac, windows)
         *   check      - regex check for string of os and version
         *   version    - regex check of osKey[x].check OR string
         *   altVersion - regex check of osKey[x].check OR string
         *   x64Check   - regex check for 64-bit of osKey[x].check
         *   x64Label   - optional string for 64-bit suffix
         */
        {
          // AIX unknown version
          family: 'AIX',
          check: /(aix) ([a-z|A-Z|0-9]{8,})/i,
          version: '',
          altVersion: /([a-z|A-Z|0-9]{8,})/
        },
        {
          // AIX known version
          family: 'AIX',
          check: /(aix) ([0-9]+_[0-9]+|[0-9]+\.[0-9]+)/i,
          version: /([0-9]+_[0-9]+|[0-9]+\.[0-9]+)/
        },
        {
          // Android
          family: 'Android',
          check: /(Android [0-9]+(\.[0-9]+)*)/i,
          version: /([0-9]+(\.[0-9]+)*)/
        },
        {
          // Debian Linux unknown version
          family: 'Linux',
          brand: 'Debian Linux',
          check: /(debian)/i,
          version: '',
          x64Check: /x86_64/
        },
        {
          // Fedora Linux unknown version
          family: 'Linux',
          brand: 'Fedora Linux',
          check: /(fedora)/i,
          version: '',
          x64Check: /x86_64/
        },
        {
          // iPad
          family: 'iPad',
          check: /(iPad; CPU OS [0-9]+(_[0-9]+)+)/i,
          version: /([0-9]+(_[0-9]+)+)/
        },
        {
          // iPhone
          family: 'iPhone',
          check: /(iPhone; CPU iPhone OS [1-9][0-9]_[0-9])/i,
          version: /([1-9][0-9]_[0-9]+)/
        },
        {
          // Lindows unknown version
          family: 'Linux',
          brand: 'Lindows',
          check: /(lindows)/i,
          version: ''
        },
        {
          // Linpus Linux unknown version
          family: 'Linux',
          brand: 'Linpus',
          check: /(linpus)/i,
          version: '',
          x64Check: /x86_64/
        },
        {
          // Linspire unknown version
          family: 'Linux',
          brand: 'Linspire',
          check: /(linspire)/i,
          version: '',
          x64Check: /x86_64/
        },
        {
          // Linux Mint any version
          family: 'Linux',
          brand: 'Linux Mint',
          check: /(linux mint)\/[0-9]+\.[0-9]+/i,
          version: /[0-9]+\.[0-9]+/,
          x64Check: /x86_64/
        },
        {
          // macOS any version (except classic Mac OS)
          // - contains the deprecated brand names of OS X and Mac OS X
          family: 'macOS',
          check: /(mac os x) ([1-9][0-9]_[0-9]+_?[0-9]+?|[1-9][0-9]\.[0-9]+\.?[0-9]?[0-9]?)/i,
          version: /([1-9][0-9]_[0-9]+_?[0-9]+?|[1-9][0-9]\.[0-9]+\.?[0-9]?[0-9]?)/
        },
        {
          // Mandrake Linux any version
          family: 'Linux',
          brand: 'Mandrake Linux',
          check: /(linux).*(mdk)/i,
          version: ''
        },
        {
          // openSUSE unknown version
          // - keep before SUSE to override that check
          family: 'Linux',
          brand: 'openSUSE Linux',
          check: /opensuse/i,
          version: ''
        },
        {
          // OS/2 unknown version
          family: 'OS/2',
          check: /os\/2/i,
          version: ''
        },
        {
          // PCLinuxOS unknown version
          family: 'Linux',
          brand: 'PCLinuxOS',
          check: /pclinuxos/i,
          version: ''
        },
        {
          // Red Hat Linux unknown version
          family: 'Linux',
          brand: 'Red Hat Linux',
          check: /rhel/i,
          version: ''
        },
        {
          // Red Hat Enterprise Linux unknown version
          family: 'Linux',
          brand: 'Red Hat Enterprise Linux',
          check: /red hat enterprise linux/i,
          version: ''
        },
        {
          // Solaris unknown version
          family: 'Solaris',
          check: /solaris/i,
          version: ''
        },
        {
          // SunOS unknown version
          family: 'SunOS',
          check: /sunos/i,
          version: ''
        },
        {
          // SUSE unknown version
          family: 'Linux',
          brand: 'SUSE Linux',
          check: /suse/i,
          version: ''
        },
        {
          // Ubuntu any version
          family: 'Linux',
          brand: 'Ubuntu',
          check: /(ubuntu)\/[0-9]+\.[0-9]+/i,
          version: /[0-9]+\.[0-9]+/,
          x64Check: /x86_64/
        },
        {
          // windows 1.0 - 3.2
          family: 'Windows',
          check: /(windows|Windows) [0-9]\.[0-9]+/,
          version: /[0-9]\.[0-9]+/,
          bit: 16
        },
        {
          // windows nt 3.1 - 4.0
          family: 'Windows',
          check: /(windows nt|Windows NT) [3-4]\.[0-9]+|(winnt|WinNT)[3-4]\.[0-9]/,
          versionPrefix: 'NT ',
          version: /[3-4]\.[0-9]+/,
          altVersionPrefix: 'NT ',
          altVersion: /[3-4]\.[0-9]+/,
          bit: 32
        },
        {
          // windows 95/98
          family: 'Windows',
          check: /(windows|Windows) [0-9][0-9]/,
          version: /[0-9][0-9]/,
          bit: 32
        },
        {
          // windows 98 se
          family: 'Windows',
          check: /(win98|Win98)/,
          version: '98 SE',
          bit: 32
        },
        {
          // windows 2000
          family: 'Windows',
          check: /(windows nt|Windows NT) 5\.0/,
          version: '2000',
          altVersion: 'NT 5.0',
          bit: 32
        },
        {
          // windows me
          family: 'Windows',
          check: /(windows me|Windows ME|Windows Me)/,
          version: 'ME',
          altVersion: '4.90',
          bit: 32
        },
        {
          // windows xp
          family: 'Windows',
          check: /(windows nt|Windows NT) 5\.1/,
          version: 'XP',
          altVersion: 'NT 5.1',
          x64Check: /wow64|WOW64|x64|win64/
        },
        {
          // windows xp professional x64 edition
          family: 'Windows',
          check: /(windows nt|Windows NT) 5\.2/,
          version: 'XP Professional x64 Edition',
          altVersion: 'NT 5.2',
          bit: 64
        },
        {
          // windows vista
          family: 'Windows',
          check: /(windows nt|Windows NT) 6\.0/,
          version: 'Vista',
          altVersion: 'NT 6.0',
          x64Check: /wow64|WOW64|x64|win64/
        },
        {
          // windows 7
          family: 'Windows',
          check: /(windows nt|Windows NT) 6\.1/,
          version: '7',
          altVersion: 'NT 6.1',
          x64Check: /wow64|WOW64|x64|win64/
        },
        {
          // windows 8
          family: 'Windows',
          check: /(windows nt|Windows NT) 6\.2/,
          version: '8',
          altVersion: 'NT 6.2',
          x64Check: /wow64|WOW64|x64|win64/
        },
        {
          // windows 8.1
          family: 'Windows',
          check: /(windows nt|Windows NT) 6\.3/,
          version: '8.1',
          altVersion: 'NT 6.3',
          x64Check: /wow64|WOW64|x64|win64/
        },
        {
          // windows 10
          family: 'Windows',
          check: /(windows nt|Windows NT) 10/,
          version: '10',
          altVersion: 'NT 10',
          x64Check: /wow64|WOW64|x64|win64/
        },
        {
          // Linux (any variety) unknown version
          // - keep at botom so specific checks override this one
          family: 'Linux',
          check: /linux/i,
          version: '',
          x64Check: /x86_64/
        }
      ];

      function addPrefix(target, prefix) {
        if (prefix) {
          target = prefix + target;
        }
        return target;
      }

      // set raw OS string fom user agent
      obj.os.raw = obj.ua;

      // check for RegEx match and set name if it matches
      for (i = 0; i < osKey.length; i++) {
        x64Suffix = ''; // reset for each iteration

        if (osKey[i].check.test(obj.os.raw)) {
          obj.os.check = obj.os.raw.match(osKey[i].check)[0];
          obj.os.family = osKey[i].family;

          // set bit depth

          // check if x64Check exists
          if (typeof osKey[i].x64Check === 'undefined') {
            // check if osKey.bit exists
            if (osKey[i].bit) {
              // set bit to custom value
              obj.os.bit = osKey[i].bit;
            } else {
              // not specified; set bit to blank
              obj.os.bit = '';
            }
          } else {
            // test if regex for 64-bit exists
            if (osKey[i].x64Check.test(obj.os.raw)) {
              obj.os.bit = 64;

              // set 64-bit suffix label
              if (osKey[i].x64Label) {
                // use custom 64-bit label (e.g., "x64")
                x64Suffix = ' ' + osKey[i].x64Label;
              } else {
                // use default 64-bit label
                x64Suffix = ' ' + DEFAULT_X64_LABEL;
              }
            } else {
              // set default bit level
              obj.os.bit = 32;
            }
          }

          // set version

          // check if version is a custom string or a regex
          if (typeof osKey[i].version === 'string') {
            // set the version number to the custom string
            obj.os.version = osKey[i].version;
          } else {
            /* 
             * use a regex to find the exact version number 
             * and match the osKey[x].version regular expression 
             * to a string WITHIN the osKey[x].check
             */
            obj.os.version = obj.os.check.match(osKey[i].version)[0];
            obj.os.version = obj.os.version.replace(/\_/g,'.');
          }

          // set version prefix
          obj.os.version = addPrefix(obj.os.version, osKey[i].versionPrefix);

          // set altVersion

           // check if altVersion is a custom string or a regex
          if (typeof osKey[i].altVersion === 'string') {
            // set the altVersion number to the custom string
            obj.os.altVersion = osKey[i].altVersion;
          } else {
            // check if altVersion is a regex or set to blank
            if (typeof osKey[i].altVersion === 'object') {
              /* 
               * use a regex to find the exact version number 
               * and match the osKey[x].version regular expression 
               * to a string WITHIN the osKey[x].check
               */
              obj.os.altVersion = obj.os.check.match(osKey[i].altVersion)[0];
            } else {
              obj.os.altVersion = '';
            }
          }

          // set alt version prefix
          obj.os.altVersion = addPrefix(obj.os.altVersion, osKey[i].altVersionPrefix);

          // set combined name
          if (osKey[i].brand) {
            obj.os.brand = osKey[i].brand;
            obj.os.name = obj.os.brand + ' ' + obj.os.version + x64Suffix;
          } else {
            // create combined name
            obj.os.name = obj.os.family + ' ' + obj.os.version + x64Suffix;
          }

          break; // match found; avoid more iterations
        }
      }

      // set name to unknown if no match found
      if (typeof result.os.family === 'undefined') {
        obj.os.family = UNKNOWN;
        obj.os.name = UNKNOWN;
        obj.os.version = UNKNOWN;
      }
    }

    if (uaStr === '') {
      result.os.name = 'NO USER AGENT';
      return result;
    } else {
      if (typeof uaStr === 'undefined') {
        result.ua = window.navigator.userAgent;
      } else {
        result.ua = uaStr;
      }

      parseOS(result);

      return result;
    }
  };
}(window.lxk = window.lxk || {}));